(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aura-artist-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('aura-artist-page')) return;
  const normalize = value => String(value || '').normalize('NFKC').replace(/[’‘]/g, "'").trim().replace(/\s+/g, ' ').toLocaleLowerCase();
  const array = value => Array.isArray(value) ? value.map(v => typeof v === 'string' ? v : v?.name || v?.title || '').filter(Boolean) : typeof value === 'string' && value.trim() ? [value.trim()] : [];
  const safeUrl = value => {
    if (typeof value !== 'string' || !value) return '';
    try { const url = new URL(value, location.origin); return ['http:', 'https:'].includes(url.protocol) ? url.href : ''; } catch { return ''; }
  };
  const element = (tag, className, text) => { const node = document.createElement(tag); if (className) node.className = className; if (text !== undefined) node.textContent = text; return node; };
  const icon = name => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg'); svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('aria-hidden', 'true');
    const path = document.createElementNS(svg.namespaceURI, 'path');
    const paths = { play: 'm9 5 11 7-11 7Z', pause: 'M7 5h4v14H7Zm6 0h4v14h-4Z', previous: 'm14.5 5-7 7 7 7', next: 'm9.5 5 7 7-7 7' };
    path.setAttribute('d', paths[name] || paths.play);
    if (['previous', 'next'].includes(name)) { path.setAttribute('fill', 'none'); path.setAttribute('stroke', 'currentColor'); path.setAttribute('stroke-width', '1.8'); path.setAttribute('stroke-linecap', 'round'); path.setAttribute('stroke-linejoin', 'round'); } else path.setAttribute('fill', 'currentColor');
    svg.append(path); return svg;
  };
  const isMusic = p => !p.shipping && Boolean(p.releaseId || p.preview || /(^|\W)(album|ep|single|song|track|music|ringtone|video)(\W|$)/i.test([p.type, p.template, ...(p.tags || [])].join(' ')));
  const albumType = p => /(^|\W)(album|ep|extended play)(\W|$)/i.test(p.type || '');
  const dateValue = p => /^\d{4}-\d{2}-\d{2}$/.test(p.date || '') && Number.isFinite(Date.parse(p.date)) ? p.date : '';
  const byDate = (a, b) => dateValue(b).localeCompare(dateValue(a)) || a.title.localeCompare(b.title) || a.id.localeCompare(b.id);
  class AuraArtistPage extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      if (!this.querySelector('[data-labels]')) { this.readyTimer = setTimeout(() => this.connectedCallback(), 0); return; }
      this.started = true;
      this.controller = new AbortController(); this.signal = this.controller.signal;
      try { this.labels = JSON.parse(this.querySelector('[data-labels]').textContent); } catch { this.labels = {}; }
      this.aliases = new Set([this.dataset.artistName, this.dataset.collectionTitle].map(normalize).filter(Boolean));
      this.products = new Map(); this.sources = new Map(); this.pageSize = Math.max(12, Number(this.dataset.pageSize) || 24);
      this.views = {music: {items: [], page: 1}, appears: {items: [], page: 1}};
      this.year = this.querySelector('[data-year]'); this.type = this.querySelector('[data-type]');
      this.status = this.querySelector('[data-status]'); this.retry = this.querySelector('[data-retry]');
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.audio = new Audio(); this.audio.preload = 'none';
      this.player = this.querySelector('[data-player]');
      if (this.player) { this.player.setAttribute('data-owner', this.dataset.sectionId); document.body.append(this.player); }
      this.on(this, 'click', event => this.handleClick(event));
      if (this.player) this.on(this.player, 'click', event => this.handleClick(event));
      this.on(this.year, 'change', () => this.renderList('music', true)); this.on(this.type, 'change', () => this.renderList('music', true));
      this.on(this.retry, 'click', () => this.loadRemaining());
      this.setupBiography(); this.setupPlayer(); this.setupPalette();
      try { this.ingest(this); this.querySelector('[data-fallback]')?.setAttribute('hidden', ''); this.querySelector('[data-music-shell]')?.removeAttribute('hidden'); this.rebuild(); this.loadRemaining(); } catch { this.setStatus('load_error'); this.retry?.removeAttribute('hidden'); }
      this.on(document, 'shopify:section:unload', event => { if (event.detail?.sectionId === this.dataset.sectionId) this.disconnectedCallback(); });
    }
    on(target, event, callback, options = {}) { target?.addEventListener(event, callback, {...options, signal: this.signal}); }
    t(key, values = {}) { let text = this.labels[key] || key; for (const [name, value] of Object.entries(values)) text = text.split(`{${name}}`).join(String(value)); return text; }
    setStatus(key) { if (this.status) { this.status.hidden = !key; this.status.textContent = key ? this.t(key) : ''; } }
    ingestFeed(feed, source) {
      if (!Array.isArray(feed.items)) throw Error('Invalid catalog');
      source.pages = Math.max(source.pages, Number(feed.pages) || 1); source.loaded.add(Number(feed.page) || 1);
      for (const item of feed.items) {
        if (!item?.id) continue; const existing = this.products.get(item.id);
        this.products.set(item.id, {...existing, ...item, own: Boolean(source.own || existing?.own)});
      }
    }
    ingest(root) {
      let found = false;
      for (const [selector, own] of [['[data-catalog-feed]', false], ['[data-artist-feed]', true]]) {
        const script = root.querySelector(selector); if (!script) continue;
        const feed = JSON.parse(script.textContent);
        const source = {own, url: safeUrl(feed.url), pages:1, loaded:new Set()};
        this.ingestFeed(feed, source); this.sources.set(selector, source); found = true;
      }
      if (!found) throw Error('Missing catalog');
    }
    async loadRemaining() {
      if (this.loading) return;
      this.loading = true; this.retry?.setAttribute('hidden', ''); this.setStatus('loading');
      try {
        for (const source of this.sources.values()) {
          for (let page = 1; page <= source.pages; page++) {
            if (this.signal.aborted) return;
            if (source.loaded.has(page)) continue;
            if (!source.url) throw Error('Missing collection URL');
            const url = new URL(source.url);
            if (url.origin !== location.origin) throw Error('Invalid collection URL');
            url.search = '';
            const themePreview = new URL(location.href).searchParams.get('preview_theme_id'); if (themePreview) url.searchParams.set('preview_theme_id', themePreview);
            url.searchParams.set('section_id', 'aura-artist-catalog-feed'); url.searchParams.set('page', String(page));
            const timeout = new AbortController(); const timer = setTimeout(() => timeout.abort(), 20000);
            const abort = () => timeout.abort(); this.signal.addEventListener('abort', abort, {once:true});
            let html;
            try { const response = await fetch(url, {credentials:'same-origin', signal:timeout.signal}); if (!response.ok) throw Error('Catalog request failed'); html = await response.text(); }
            finally { clearTimeout(timer); this.signal.removeEventListener('abort', abort); }
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const node = doc.querySelector('[data-catalog-page]'); if (!node) throw Error('Missing catalog section');
            const feed = JSON.parse(node.textContent); if (Number(feed.page) !== page) throw Error('Unexpected catalog page');
            this.ingestFeed(feed,source); this.rebuild();
          }
        }
        this.setStatus('');
      } catch (error) { if (!this.signal.aborted) { this.setStatus('load_error'); this.retry?.removeAttribute('hidden'); } }
      finally { this.loading = false; }
    }
    primaryNames(p) {
      const raw = String(p.primary || '').trim(); const list = array(p.primaryList);
      if (list.length && (!raw || normalize(list.join(' & ')) === normalize(raw))) return list;
      if (raw && this.aliases.has(normalize(raw))) return [raw];
      return raw ? raw.split(/\s+&\s+/).filter(Boolean) : list.length ? list : array(p.vendor);
    }
    relationship(p) {
      const primary = this.primaryNames(p); const featured = array(p.featured);
      const index = primary.findIndex(name => this.aliases.has(normalize(name)));
      if (index === 0) return 'lead'; if (index > 0) return 'co_primary';
      if (featured.some(name => this.aliases.has(normalize(name)))) return 'feature';
      if (!primary.length && p.own) return 'lead'; return '';
    }
    rebuild() {
      const all = [...this.products.values()]; const music = all.filter(isMusic); const byId = new Map(music.map(p => [p.id, p]));
      const parents = new Map();
      music.filter(p => !p.trackId && (albumType(p) || Number(p.trackCount) > 1)).forEach(p => { if (p.releaseId) parents.set(p.releaseId, p); });
      const groups = new Map();
      for (const track of music) {
        const directParent = track.parentId ? byId.get(track.parentId) || track.parent : null;
        const head = directParent || parents.get(track.releaseId) || track;
        const key = head.id; if (!key) continue;
        if (!groups.has(key)) groups.set(key, {head, members:[]});
        groups.get(key).members.push(track);
      }
      const releases = [], appearances = [];
      for (const {head, members} of groups.values()) {
        const mainRole = this.relationship(head); const otherRoles = members.map(p => this.relationship(p));
        if (!mainRole && !otherRoles.some(Boolean)) continue;
        const source = {...head};
        if (!source.preview && source.previewAllowed !== false) source.preview = members.filter(p => p.preview).sort((a,b) => (Number(a.trackNumber)||999) - (Number(b.trackNumber)||999))[0]?.preview || '';
        if (!source.image) source.image = members.find(p => p.image)?.image || '';
        if (!source.date) source.date = members.find(p => p.date)?.date || '';
        source.primary = source.primary || this.primaryNames(head).join(' & '); source.type = source.type || 'Single';
        source.role = mainRole === 'lead' ? 'lead' : mainRole === 'co_primary' || otherRoles.includes('lead') || otherRoles.includes('co_primary') ? 'co_primary' : 'feature';
        if (source.role === 'lead') releases.push(source); else appearances.push(source);
      }
      this.views.music.items = releases.sort(byDate); this.views.appears.items = appearances.sort(byDate);
      this.releaseLookup = new Map([...releases,...appearances].map(p => [p.id,p]));
      const year = this.year?.value || ''; const years = [...new Set(releases.map(p => dateValue(p).slice(0,4)).filter(Boolean))].sort().reverse();
      if (this.year) { this.year.replaceChildren(new Option(this.t('all_years'),''),...years.map(value=>new Option(value,value))); this.year.value = years.includes(year) ? year : ''; }
      this.renderShowcase(); this.renderList('music'); this.renderList('appears');
      for (const kind of ['physical','merch']) {
        const section = this.querySelector(`[data-shop="${kind}"]`); if (!section) continue;
        const items = all.filter(p => p.own && p.shipping).filter(p => {
          const physical = /(^|\W)(cd|vinyl|cassette|album|music)(\W|$)/i.test([p.type,p.title,...(p.tags||[])].join(' ')); return kind === 'physical' ? physical : !physical;
        });
        section.hidden = !items.length; section.querySelector('[data-grid]').replaceChildren(...items.map(p=>this.card(p,false,true)));
      }
      const achievements = this.querySelector('.artist-achievements'); if (achievements && !achievements.querySelector('.artist-achievement')) achievements.hidden = true;
      this.syncPlayer();
    }
    formatDate(p) { if (!dateValue(p)) return ''; try { return new Intl.DateTimeFormat(document.documentElement.lang || 'en', {month:'short',year:'numeric',timeZone:'UTC'}).format(new Date(`${p.date}T12:00:00Z`)); } catch { return p.date; } }
    releaseType(p) { if (albumType(p)) return /(^|\W)ep(\W|$)/i.test(p.type) ? this.t('ep') : this.t('album'); return /single|song|track/i.test(p.type) ? this.t('single') : p.type; }
    art(p, className, eager = false) {
      const link = element('a',className); link.href = safeUrl(p.url) || '#'; link.setAttribute('aria-label',p.title);
      const url = safeUrl(p.image); if (url) { const img = element('img'); img.src = url; img.alt = ''; img.width = 360; img.height = 360; img.loading = eager ? 'eager':'lazy'; img.decoding = 'async'; if(eager) img.fetchPriority = 'high'; link.append(img); }
      else { const placeholder = icon('play'); placeholder.style.cssText='width:30%;height:100%;margin:auto;display:block;opacity:.3'; link.append(placeholder); }
      return link;
    }
    playButton(p, className = 'artist-card__play') {
      const button = element('button',className); button.type='button'; button.dataset.play = p.id;
      button.setAttribute('aria-label',this.t('play',{title:p.title})); button.setAttribute('aria-pressed','false'); button.append(icon('play')); return button;
    }
    card(p, appearance=false, shop=false) {
      const card = element('article','artist-card'); card.append(this.art(p,'artist-card__image'));
      const copy = element('div','artist-card__copy'), heading = element('h3'), link=element('a','',p.title); link.href=safeUrl(p.url)||'#'; heading.append(link); copy.append(heading);
      const detail = shop ? [p.price,!p.available?this.t('sold_out'):''].filter(Boolean).join(' · ') : [appearance ? p.primary : this.releaseType(p),this.formatDate(p)].filter(Boolean).join(' · ');
      copy.append(element('p','artist-card__meta',detail));
      if (appearance) copy.append(element('p','artist-card__role',this.t(p.role)));
      card.append(copy); if (safeUrl(p.preview)&&!shop) card.append(this.playButton(p)); return card;
    }
    renderShowcase() {
      const wrap=this.querySelector('[data-showcase]'); if(!wrap)return;
      const releases=this.views.music.items; const released=releases.filter(p=>!p.date||p.date<=this.dataset.today);
      const featured=released[0] || [...releases].reverse()[0];
      wrap.hidden=!featured;if(!featured)return;
      const panel=element('article','artist-feature');panel.append(this.art(featured,'artist-feature__art',true));
      const copy=element('div','artist-feature__copy');copy.append(element('p','artist-eyebrow',this.t(featured.date>this.dataset.today?'upcoming':'latest')));
      const heading=element('h2'),title=element('a','',featured.title);title.href=safeUrl(featured.url)||'#';heading.append(title);copy.append(heading);
      copy.append(element('p','artist-feature__meta',[this.releaseType(featured),this.formatDate(featured)].filter(Boolean).join(' · ')));
      const actions=element('div','artist-feature__actions');
      if(safeUrl(featured.preview)){const button=this.playButton(featured,'artist-button artist-button--primary');button.append(element('span','',this.t('preview')));actions.append(button);}
      const link=element('a',`artist-button${featured.preview?'':' artist-button--primary'}`,this.t('view'));link.href=safeUrl(featured.url)||'#';actions.append(link);copy.append(actions);panel.append(copy);
      const recent=element('div','artist-recent');releases.filter(p=>p.id!==featured.id).slice(0,2).forEach(p=>recent.append(this.card(p)));
      wrap.replaceChildren(panel);if(recent.children.length)wrap.append(recent);else wrap.style.gridTemplateColumns='minmax(0,1fr)';
      if(recent.children.length)wrap.style.gridTemplateColumns='';
    }
    renderList(kind, reset=false, focus=false) {
      const section=this.querySelector(`[data-list="${kind}"]`);if(!section)return;
      const state=this.views[kind];let items=state.items;
      if(kind==='music')items=items.filter(p=>(!this.year?.value||dateValue(p).startsWith(this.year.value))&&(!this.type?.value||(this.type.value==='album'?albumType(p):!albumType(p))));
      if(reset)state.page=1;const pages=Math.max(1,Math.ceil(items.length/this.pageSize));state.page=Math.min(state.page,pages);
      section.hidden=kind==='appears'&&!items.length;
      const start=(state.page-1)*this.pageSize;section.querySelector('[data-grid]').replaceChildren(...items.slice(start,start+this.pageSize).map(p=>this.card(p,kind==='appears')));
      const count=section.querySelector('[data-count]');if(count)count.textContent=items.length===1?this.t('count_one'):this.t('count',{count:items.length});
      const empty=section.querySelector('[data-empty]');if(empty){empty.hidden=Boolean(items.length);empty.textContent=this.t(state.items.length?'no_matches':'no_releases');}
      const pagination=section.querySelector('[data-pagination]');pagination.hidden=pages<=1;pagination.replaceChildren();
      const pageButton=(page,label,direction)=>{const b=element('button','',direction?'':String(page));b.type='button';b.dataset.page=String(page);b.dataset.list=kind;b.setAttribute('aria-label',label);if(direction)b.append(icon(direction));if(page===state.page&&!direction)b.setAttribute('aria-current','page');return b;};
      const prev=pageButton(state.page-1,this.t('previous'),'previous');prev.disabled=state.page===1;pagination.append(prev);
      let last=0;
      for(const page of [...new Set(matchMedia('(max-width:600px)').matches?[1,pages,state.page]:[1,pages,state.page-1,state.page,state.page+1])].filter(p=>p>=1&&p<=pages).sort((a,b)=>a-b)){
        if(last&&page>last+1)pagination.append(element('span','artist-page-ellipsis','…'));
        pagination.append(pageButton(page,this.t('page',{page})));last=page;
      }
      const next=pageButton(state.page+1,this.t('next'),'next');next.disabled=state.page===pages;pagination.append(next);
      const status=element('span','',this.t('page_status',{start:items.length?start+1:0,end:Math.min(start+this.pageSize,items.length),count:items.length}));status.setAttribute('aria-live','polite');pagination.append(status);
      if(focus){const heading=section.querySelector('h2');heading.focus({preventScroll:true});section.scrollIntoView({behavior:this.reducedMotion?'instant':'smooth',block:'start'});}
      this.syncPlayer();
    }
    handleClick(event) {
      const play=event.target.closest('[data-play]');if(play){const release=this.releaseLookup?.get(play.dataset.play);if(release)this.toggleRelease(release);return;}
      const page=event.target.closest('[data-page]');if(page){this.views[page.dataset.list].page=Number(page.dataset.page);this.renderList(page.dataset.list,false,true);return;}
      if(event.target.closest('[data-player-toggle]')){if(this.current)this.toggleRelease(this.current);return;}
      if(event.target.closest('[data-player-close]')){this.audio.pause();this.player.hidden=true;this.style.paddingBottom='';return;}
    }
    setupBiography() {
      const dialog=this.querySelector('dialog'),open=this.querySelector('[data-bio-open]'),source=this.querySelector('[data-bio-source]');if(!dialog||!open||!source)return;
      this.on(open,'click',event=>{if(typeof dialog.showModal!=='function')return;event.preventDefault();const body=this.querySelector('[data-bio-body]');body.replaceChildren(...[...source.childNodes].map(node=>node.cloneNode(true)));dialog.showModal();});
      this.on(this.querySelector('[data-bio-close]'),'click',()=>dialog.close());
      this.on(dialog,'click',event=>{if(event.target===dialog){const box=dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)dialog.close();}});
      this.on(dialog,'close',()=>open.focus({preventScroll:true}));
    }
    setupPlayer() {
      if(!this.player)return;
      const seek=this.player.querySelector('[data-seek]');
      this.on(seek,'input',()=>{if(!this.current)return;const value=Number(seek.value);if(Number.isFinite(value))this.audio.currentTime=Math.min(value,this.previewDuration());this.syncPlayer();});
      for(const event of ['play','pause','loadedmetadata','durationchange','ended'])this.on(this.audio,event,()=>this.syncPlayer());
      this.on(this.audio,'timeupdate',()=>{if(this.audio.currentTime>=this.previewDuration()){this.audio.pause();this.audio.currentTime=0;}this.syncPlayer();});
      this.on(this.audio,'error',()=>{this.audio.pause();this.setStatus('preview_error');this.syncPlayer();});
      this.on(document,'play',event=>{if(event.target!==this.audio&&!this.audio.paused)this.audio.pause();},{capture:true});
      this.on(document,'aura:artist-preview',event=>{if(event.detail?.owner!==this.dataset.sectionId)this.audio.pause();});
    }
    previewDuration(){return Number.isFinite(this.audio.duration)&&this.audio.duration>0?Math.min(60,this.audio.duration):60;}
    toggleRelease(release) {
      const url=safeUrl(release.preview);if(!url)return;
      if(this.current?.id===release.id&&!this.audio.paused){this.audio.pause();return;}
      if(this.current?.id!==release.id){this.audio.pause();this.audio.src=url;this.current=release;}
      if(this.audio.currentTime>=this.previewDuration()-.1)this.audio.currentTime=0;
      document.querySelectorAll('audio,video').forEach(media=>{if(!media.paused)media.pause();});
      document.dispatchEvent(new CustomEvent('aura:artist-preview',{detail:{owner:this.dataset.sectionId}}));
      this.player.hidden=false;this.style.paddingBottom=matchMedia('(max-width:600px)').matches?'140px':'100px';
      const art=this.player.querySelector('[data-player-art]');const image=safeUrl(release.image);art.hidden=!image;if(image)art.src=image;
      this.player.querySelector('[data-player-title]').textContent=release.title;this.player.querySelector('[data-player-artist]').textContent=release.primary||this.dataset.artistName;
      this.player.querySelector('[data-player-link]').href=safeUrl(release.url)||'#';
      this.audio.play().catch(()=>{this.setStatus('preview_error');this.syncPlayer();});this.syncPlayer();
    }
    syncPlayer() {
      if(!this.audio||!this.player)return;const playing=Boolean(this.current&&!this.audio.paused);
      for(const button of this.querySelectorAll('[data-play]')){const active=this.current?.id===button.dataset.play&&playing;button.setAttribute('aria-pressed',String(active));const release=this.releaseLookup?.get(button.dataset.play);button.setAttribute('aria-label',this.t(active?'pause':'play',{title:release?.title||''}));const svg=button.querySelector('svg');if(svg)svg.replaceWith(icon(active?'pause':'play'));}
      this.player.classList.toggle('is-playing',playing);const toggle=this.player.querySelector('[data-player-toggle]');toggle.replaceChildren(icon(playing?'pause':'play'));toggle.setAttribute('aria-label',this.t(playing?'pause_short':'play_short'));toggle.setAttribute('aria-pressed',String(playing));
      const duration=this.previewDuration();const time=Math.min(this.audio.currentTime||0,duration);const seek=this.player.querySelector('[data-seek]');seek.max=String(duration);seek.value=String(time);
      const fmt=value=>`${Math.floor(value/60)}:${String(Math.floor(value%60)).padStart(2,'0')}`;
      this.player.querySelector('[data-time]').textContent=`${fmt(time)} / ${fmt(duration)}`;seek.setAttribute('aria-valuetext',`${fmt(time)} / ${fmt(duration)}`);
      [...this.player.querySelectorAll('.artist-wave i')].forEach((bar,index,bars)=>bar.classList.toggle('is-past',index/bars.length<time/duration));
    }
    setupPalette() {
      const avatar=this.querySelector('.artist-avatar img');if(!avatar)return;
      const image=new Image();image.crossOrigin='anonymous';this.paletteImage=image;
      this.on(image,'load',()=>{try{
        const canvas=document.createElement('canvas');canvas.width=40;canvas.height=40;const ctx=canvas.getContext('2d',{willReadFrequently:true});if(!ctx)return;ctx.drawImage(image,0,0,40,40);
        const data=ctx.getImageData(0,0,40,40).data;const bins=[[0,0,0,0],[0,0,0,0]];
        for(let i=0;i<data.length;i+=4){if(data[i+3]<180)continue;const rgb=[data[i],data[i+1],data[i+2]],max=Math.max(...rgb),min=Math.min(...rgb);if(max<25||min>235)continue;const weight=.5+(max-min)/100;const bin=bins[(i/4)%40<20?0:1];rgb.forEach((v,k)=>bin[k]+=v*weight);bin[3]+=weight;}
        if(!bins.some(bin=>bin[3]))return;
        const colors=bins.map((bin,index)=>{if(!bin[3])bin=bins[1-index];return bin.slice(0,3).map(v=>Math.round(Math.min(210,Math.max(55,v/bin[3]))));});
        this.style.setProperty('--era-a',colors[0].join(','));this.style.setProperty('--era-b',colors[1].join(','));
        for(const target of [this,this.player]){if(!target)continue;target.style.setProperty('--era-a',colors[0].join(','));target.style.setProperty('--era-b',colors[1].join(','));}
        document.dispatchEvent(new CustomEvent('aura:setpalette',{detail:{primary:colors[0],secondary:colors[1],source:'artist'}}));
      }catch{}},{once:true});
      image.src=avatar.currentSrc||avatar.src;
      if(this.player){const style=getComputedStyle(this);for(const name of ['--era-a','--era-b'])this.player.style.setProperty(name,style.getPropertyValue(name));}
    }
    disconnectedCallback() {
      clearTimeout(this.readyTimer);this.controller?.abort();
      if(this.audio){this.audio.pause();this.audio.removeAttribute('src');this.audio.load();}
      this.querySelector('dialog[open]')?.close();this.player?.remove();this.started=false;
    }
  }
  customElements.define('aura-artist-page',AuraArtistPage);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aura-directory-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  const norm=value=>String(value||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
  const states=Object.fromEntries('AL:Alabama|AK:Alaska|AZ:Arizona|AR:Arkansas|CA:California|CO:Colorado|CT:Connecticut|DE:Delaware|FL:Florida|GA:Georgia|HI:Hawaii|ID:Idaho|IL:Illinois|IN:Indiana|IA:Iowa|KS:Kansas|KY:Kentucky|LA:Louisiana|ME:Maine|MD:Maryland|MA:Massachusetts|MI:Michigan|MN:Minnesota|MS:Mississippi|MO:Missouri|MT:Montana|NE:Nebraska|NV:Nevada|NH:New Hampshire|NJ:New Jersey|NM:New Mexico|NY:New York|NC:North Carolina|ND:North Dakota|OH:Ohio|OK:Oklahoma|OR:Oregon|PA:Pennsylvania|RI:Rhode Island|SC:South Carolina|SD:South Dakota|TN:Tennessee|TX:Texas|UT:Utah|VT:Vermont|VA:Virginia|WA:Washington|WV:West Virginia|WI:Wisconsin|WY:Wyoming|DC:District of Columbia|PR:Puerto Rico'.split('|').map(item=>item.split(':')));
  const stateName=value=>states[String(value||'').trim().toUpperCase()]||Object.values(states).find(name=>norm(name)===norm(value))||'';
  const countryAlias=value=>({usa:'united states',us:'united states','united states of america':'united states',uk:'united kingdom',gb:'united kingdom'})[norm(value)]||norm(value);
  const locationQuery=location=>{
    const parts=String(location).split(/,|·/).map(p=>p.trim()).filter(Boolean);
    const firstState=stateName(parts[0]);
    const isRegion=Boolean(firstState&&(parts.length===1||(parts.length===2&&countryAlias(parts[1])==='united states')));
    const secondState=parts.length>1?stateName(parts[1]):'';
    const country=isRegion||secondState?'US':'';
    if(isRegion)parts[0]=firstState;
    else if(secondState)parts[1]=secondState;
    return {parts,country,region:isRegion,query:parts.filter(p=>!country||countryAlias(p)!=='united states').join(', ')};
  };
  const choosePoint=(location,features)=>{
    const request=locationQuery(location);
    const matches=features.filter(feature=>{
      const p=feature.properties||{},coords=feature.geometry?.coordinates;
      if(feature.geometry?.type!=='Point'||!Array.isArray(coords)||coords.length<2||!coords.every(Number.isFinite)||Math.abs(coords[0])>180||Math.abs(coords[1])>90)return false;
      if(!['city','state','country'].includes(p.type))return false;
      if(request.country&&p.countrycode!=='US')return false;
      if(request.region&&p.type!=='state')return false;
      if(norm(p.name)!==norm(request.parts[0]))return false;
      const values=[p.name,p.city,stateName(p.state)||p.state,p.country,p.countrycode].filter(Boolean).map(countryAlias);
      return request.parts.slice(1).every(part=>values.includes(countryAlias(stateName(part)||part)));
    });
    const unique=new Map(matches.map(f=>{const p=f.properties;return [[p.type,norm(p.name),norm(p.state),p.countrycode].join('|'),f];}));
    if(unique.size!==1)return null;
    const match=[...unique.values()][0];
    return {lon:match.geometry.coordinates[0],lat:match.geometry.coordinates[1],regional:match.properties.type!=='city',type:match.properties.type};
  };
  const project=point=>[(point.lon+180)/360*1000,(90-point.lat)/180*500];
  const geo=window.auraDirectoryGeo||(window.auraDirectoryGeo={tail:Promise.resolve(),last:0,cache:new Map()});
  const locate=(location,endpoint,signal)=>{
    const key=endpoint+'|'+norm(location),storageKey='aura-directory-geo-v1:'+key;
    const task=async()=>{
      signal.throwIfAborted();
      if(geo.cache.has(key))return geo.cache.get(key);
      try{const saved=JSON.parse(localStorage.getItem(storageKey));if(saved&&Date.now()-saved.time<2592000000&&Number.isFinite(saved.point?.lon)&&Number.isFinite(saved.point?.lat)){geo.cache.set(key,saved.point);return saved.point;}}catch{}
      const wait=Math.max(0,1100-(Date.now()-geo.last));
      if(wait)await new Promise(resolve=>setTimeout(resolve,wait));
      signal.throwIfAborted();geo.last=Date.now();
      const request=locationQuery(location),url=new URL(endpoint);
      if(url.protocol!=='https:')throw new Error('Location endpoint must use HTTPS');
      url.searchParams.set('q',request.query);url.searchParams.set('limit','8');url.searchParams.set('lang','en');url.searchParams.delete('layer');
      for(const layer of ['city','state','country'])url.searchParams.append('layer',layer);
      if(request.country)url.searchParams.set('countrycode',request.country);
      const response=await fetch(url,{signal:AbortSignal.any([signal,AbortSignal.timeout(10000)]),credentials:'omit',referrerPolicy:'no-referrer'});
      if(!response.ok)throw new Error('Location lookup unavailable');
      const data=await response.json();const point=choosePoint(location,data.features||[]);
      geo.cache.set(key,point);
      if(point){try{localStorage.setItem(storageKey,JSON.stringify({time:Date.now(),point}));}catch{}}
      return point;
    };
    const promise=geo.tail.then(task);geo.tail=promise.catch(()=>{});return promise;
  };
  const svgNode=(tag,attrs={})=>{const node=document.createElementNS('http://www.w3.org/2000/svg',tag);for(const [key,value]of Object.entries(attrs))node.setAttribute(key,String(value));return node;};
  class ArtistDirectory extends HTMLElement {
    connectedCallback(){if(this.controller&&!this.controller.signal.aborted)return;this.controller=new AbortController();this.start().catch(()=>{this.querySelector('[data-ad-paging]')?.removeAttribute('hidden');});}
    disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();this.mapObserver?.disconnect();this.resizeObserver?.disconnect();clearTimeout(this.timer);cancelAnimationFrame(this.paletteFrame);}
    on(node,event,fn){node?.addEventListener(event,fn,{signal:this.controller.signal});}
    text(key){return this.labels[key]||key;}
    async start(){
      this.labels=JSON.parse(this.querySelector('[data-ad-labels]').textContent);
      this.search=this.querySelector('[data-ad-search]');this.locationSelect=this.querySelector('[data-ad-location]');this.genreSelect=this.querySelector('[data-ad-genre]');this.grid=this.querySelector('[data-ad-grid]');this.page=1;this.size=Number(this.dataset.pageSize)||24;this.motion=!matchMedia('(prefers-reduced-motion:reduce)').matches;
      this.map=this.querySelector('[data-ad-map]');this.points=new Map();this.mapStarted=false;this.resolving=false;this.manualView=false;this.view=[0,0,1000,500];
      this.cards=[...this.querySelectorAll('[data-ad-person]')];this.filtered=[];
      this.on(this.search,'input',()=>{clearTimeout(this.timer);this.timer=setTimeout(()=>{this.page=1;this.render();},100);});
      for(const control of [this.locationSelect,this.genreSelect])this.on(control,'change',()=>{this.page=1;this.render();});
      this.on(this.querySelector('[data-ad-clear]'),'click',()=>{if(this.search)this.search.value='';this.locationSelect.value='';this.genreSelect.value='';this.page=1;this.manualView=false;this.render();});
      this.on(this.querySelector('[data-ad-fit]'),'click',()=>{this.manualView=false;this.drawMap();});
      this.on(this.querySelector('[data-ad-world]'),'click',()=>{this.manualView=true;this.view=[0,0,1000,500];this.drawMap();});
      this.querySelectorAll('[data-ad-zoom]').forEach(button=>this.on(button,'click',()=>{const factor=button.dataset.adZoom==='in' ? .7 : 1/.7;const [x,y,w,h]=this.view;const width=Math.min(1000,Math.max(40,w*factor)),height=width*h/w;this.view=[x+w/2-width/2,y+h/2-height/2,width,height];this.manualView=true;this.drawMap();}));
      this.observer='IntersectionObserver'in window?new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){this.sample(entry.target);this.observer.unobserve(entry.target);}}),{rootMargin:'100px'}):null;
      this.refresh();this.render();
      await this.hydrate();if(!this.isConnected||this.controller.signal.aborted)return;
      this.refresh();this.render();
      if(this.map){
        this.resizeObserver='ResizeObserver'in window?new ResizeObserver(()=>{if(this.mapStarted)this.drawMap();}):null;this.resizeObserver?.observe(this.map);
        if('IntersectionObserver'in window){this.mapObserver=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){this.mapObserver.disconnect();this.resolveLocations();}},{rootMargin:'150px'});this.mapObserver.observe(this.map);}else this.resolveLocations();
      }
    }
    async hydrate(){
      const paging=this.querySelector('[data-ad-paging]');if(!paging)return;
      let next=paging.dataset.next;
      if(Number(paging.dataset.current)>1){const first=new URL(location.href);first.searchParams.set(paging.dataset.pageParam||'page','1');next=first.href;}
      const seen=new Set(this.cards.map(card=>card.dataset.id)),visited=new Set();
      try{
        while(next&&visited.size<100){
          const url=new URL(next,location.origin);if(url.origin!==location.origin||visited.has(url.href))throw new Error('Invalid directory page');visited.add(url.href);url.searchParams.set('section_id',this.dataset.sectionId);
          const response=await fetch(url,{signal:AbortSignal.any([this.controller.signal,AbortSignal.timeout(15000)]),credentials:'same-origin'});if(!response.ok)throw new Error('Directory unavailable');
          const doc=new DOMParser().parseFromString(await response.text(),'text/html');const root=[...doc.querySelectorAll('aura-artist-directory')].find(node=>node.dataset.instanceId===this.dataset.instanceId);if(!root)throw new Error('Missing directory');
          root.querySelectorAll('[data-ad-person]').forEach(card=>{if(!seen.has(card.dataset.id)){seen.add(card.dataset.id);this.grid.append(card);}});next=root.querySelector('[data-ad-paging]')?.dataset.next||'';
        }
        paging.hidden=!next;
      }catch{if(this.controller.signal.aborted)return;paging.hidden=false;}
      if(next&&!paging.hidden){const nav=paging.querySelector('nav');const link=document.createElement('a');link.href=next;link.textContent=this.text('more');nav.replaceChildren(link);paging.querySelector('p').textContent=this.text('more');}
    }
    refresh(){
      this.cards=[...this.grid.querySelectorAll('[data-ad-person]')].sort((a,b)=>a.dataset.name.localeCompare(b.dataset.name,undefined,{sensitivity:'base'}));
      for(const [select,field,key]of [[this.locationSelect,'location','all_locations'],[this.genreSelect,'genre','all_genres']]){
        const previous=select.value;const option=document.createElement('option');option.value='';option.textContent=this.text(key);select.replaceChildren(option);
        const values=new Map();this.cards.forEach(card=>{if(card.dataset[field])values.set(norm(card.dataset[field]),card.dataset[field]);});
        [...values].sort((a,b)=>a[1].localeCompare(b[1])).forEach(([value,label])=>{const option=document.createElement('option');option.value=value;option.textContent=label;select.append(option);});select.value=previous;
      }
      this.cards.forEach(card=>{if(this.observer)this.observer.observe(card);else this.sample(card);if(!card.dataset.adBound){card.dataset.adBound='true';this.on(card,'pointerenter',()=>this.tint(card));this.on(card,'focus',()=>this.tint(card));}});
    }
    render(){
      const query=norm(this.search?.value),location=this.locationSelect.value,genre=this.genreSelect.value;
      this.filtered=this.cards.filter(card=>(!query||norm([card.dataset.name,card.dataset.location,card.dataset.genre].join(' ')).includes(query))&&(!location||norm(card.dataset.location)===location)&&(!genre||norm(card.dataset.genre)===genre));
      const pages=Math.max(1,Math.ceil(this.filtered.length/this.size));this.page=Math.min(this.page,pages);const visible=this.filtered.slice((this.page-1)*this.size,this.page*this.size);const set=new Set(visible);
      this.cards.forEach(card=>{card.hidden=!set.has(card);});visible.forEach(card=>this.grid.append(card));
      this.grid.hidden=!this.filtered.length;this.querySelector('[data-ad-empty]').hidden=Boolean(this.filtered.length);
      this.querySelector('[data-ad-count]').textContent=`${this.filtered.length} ${this.text(this.filtered.length===1?'artist':'artists')}`;
      this.querySelector('[data-ad-clear]').hidden=!query&&!location&&!genre;
      const nav=this.querySelector('[data-ad-pages]');nav.replaceChildren();nav.hidden=pages<=1;
      const make=(page,label,aria)=>{const button=document.createElement('button');button.type='button';button.textContent=label;button.setAttribute('aria-label',aria);button.disabled=page<1||page>pages;if(page===this.page)button.setAttribute('aria-current','page');this.on(button,'click',()=>{this.page=page;this.render();this.grid.focus({preventScroll:true});this.grid.scrollIntoView({behavior:this.motion?'smooth':'instant',block:'start'});});return button;};
      nav.append(make(this.page-1,'‹',this.text('previous')));[...new Set([1,this.page-1,this.page,this.page+1,pages])].filter(n=>n>0&&n<=pages).sort((a,b)=>a-b).forEach(n=>nav.append(make(n,String(n),`${this.text('page')} ${n}`)));nav.append(make(this.page+1,'›',this.text('next')));
      if(this.map)this.drawMap();
    }
    sample(card){
      if(card.dataset.adSampled)return;const image=card.querySelector('.ad-photo');if(!image)return;
      const run=()=>{try{
        const canvas=document.createElement('canvas');canvas.width=canvas.height=24;const ctx=canvas.getContext('2d',{willReadFrequently:true});if(!ctx)return;ctx.drawImage(image,0,0,24,24);const pixels=ctx.getImageData(0,0,24,24).data;const buckets=new Map();
        for(let i=0;i<pixels.length;i+=4){const color=[pixels[i],pixels[i+1],pixels[i+2]],high=Math.max(...color),low=Math.min(...color);if(high<35||low>235)continue;const key=color.map(v=>Math.round(v/40)*40).join(',');const b=buckets.get(key)||{n:0,color};b.n+=.2+(high-low)/255*3;buckets.set(key,b);}
        const ranked=[...buckets.values()].sort((a,b)=>b.n-a.n);if(!ranked.length)return;const brighten=c=>c.map(v=>Math.round(v*.68+160*.32));const a=brighten(ranked[0].color),b=brighten(ranked.find(v=>v.color.some((n,i)=>Math.abs(n-ranked[0].color[i])>60))?.color||ranked[0].color);
        card.style.setProperty('--artist-accent',a.join(','));card.style.setProperty('--artist-accent-2',b.join(','));card.dataset.palette=JSON.stringify([a,b]);if(!this.initialTint){this.initialTint=true;this.tint(card);}
      }catch{}card.dataset.adSampled='true';};
      if(image.complete&&image.naturalWidth)run();else this.on(image,'load',run);
    }
    tint(card){
      if(!card.dataset.palette)return;cancelAnimationFrame(this.paletteFrame);const [primary,secondary]=JSON.parse(card.dataset.palette);const styles=getComputedStyle(this);const begin=['--ad-accent','--ad-secondary'].map(key=>styles.getPropertyValue(key).split(',').map(Number));const started=performance.now(),duration=this.motion?900:1;
      const frame=time=>{if(!this.isConnected)return;const t=Math.min(1,(time-started)/duration),ease=1-Math.pow(1-t,3);const colors=[primary,secondary].map((target,i)=>target.map((v,c)=>Math.round(begin[i][c]+(v-begin[i][c])*ease)));
        this.style.setProperty('--ad-accent',colors[0].join(','));this.style.setProperty('--ad-secondary',colors[1].join(','));this.style.setProperty('--erartists-accent',colors[0].join(','));this.style.setProperty('--erartists-accent-2',colors[1].join(','));this.style.setProperty('--ad-fg',colors[0].map(v=>Math.round(250*.88+v*.12)).join(','));this.style.setProperty('--ad-muted',colors[0].map(v=>Math.round(220*.8+v*.2)).join(','));
        document.dispatchEvent(new CustomEvent('aura:setpalette',{detail:{primary:colors[0],secondary:colors[1],source:'artist-directory'}}));if(t<1)this.paletteFrame=requestAnimationFrame(frame);
      };this.paletteFrame=requestAnimationFrame(frame);
    }
    groups(){
      const groups=new Map();this.filtered.forEach(card=>{const location=card.dataset.location,key=norm(location);if(!key)return;const group=groups.get(key)||{key,label:location,cards:[],point:this.points.get(key)};group.cards.push(card);groups.set(key,group);});return [...groups.values()].sort((a,b)=>b.cards.length-a.cards.length||a.label.localeCompare(b.label));
    }
    selectLocation(key){this.locationSelect.value=this.locationSelect.value===key?'':key;this.page=1;this.manualView=false;this.render();this.grid.focus({preventScroll:true});this.grid.scrollIntoView({behavior:this.motion?'smooth':'instant',block:'start'});}
    async resolveLocations(){
      if(this.mapStarted)return;this.mapStarted=true;this.resolving=true;this.drawMap();
      const locations=new Map(this.cards.filter(card=>card.dataset.location).map(card=>[norm(card.dataset.location),card.dataset.location]));
      for(const [key,label]of locations){
        if(!this.isConnected||this.controller.signal.aborted)return;
        try{const point=await locate(label,this.dataset.geocoder,this.controller.signal);if(point)this.points.set(key,point);}catch{if(this.controller.signal.aborted)return;this.lookupFailed=true;break;}
        this.drawMap();
      }
      this.resolving=false;this.drawMap();
    }
    drawMap(){
      const groups=this.groups(),mapped=groups.filter(group=>group.point);const located=mapped.reduce((n,g)=>n+g.cards.length,0),unmapped=this.filtered.length-located;
      this.querySelector('[data-ad-map-count]').textContent=`${located} ${this.text('mapped')}${unmapped?' · '+unmapped+' '+this.text('unmapped'):''}`;
      const status=this.querySelector('[data-ad-map-status]');status.textContent=!this.mapStarted||this.resolving?this.text('map_loading'):!mapped.length?(groups.length?this.text('map_unavailable'):this.text('map_none')):groups.some(g=>!g.point)?this.text('map_unavailable'):'';status.hidden=!status.textContent;
      const width=this.map.getBoundingClientRect().width||900,height=this.map.getBoundingClientRect().height||390;
      if(!this.manualView){
        if(mapped.length){const xy=mapped.map(g=>project(g.point)),xs=xy.map(p=>p[0]),ys=xy.map(p=>p[1]);const w=Math.max(120,Math.max(...xs)-Math.min(...xs)+65),h=Math.max(65,Math.max(...ys)-Math.min(...ys)+45);const vw=Math.min(1000,Math.max(w,h*width/height)),vh=vw*height/width;this.view=[(Math.min(...xs)+Math.max(...xs))/2-vw/2,(Math.min(...ys)+Math.max(...ys))/2-vh/2,vw,vh];}
        else this.view=[0,0,1000,500];
      }
      this.map.setAttribute('viewBox',this.view.join(' '));const unit=Math.max(this.view[2]/width,this.view[3]/height);
      const heat=this.querySelector('[data-ad-heat]'),points=this.querySelector('[data-ad-points]');heat.replaceChildren();points.replaceChildren();
      for(const group of mapped){
        const [x,y]=project(group.point),n=group.cards.length;heat.append(svgNode('circle',{cx:x,cy:y,r:(22+Math.sqrt(n)*15)*unit,fill:`url(#ADHeat-${this.dataset.instanceId})`,opacity:Math.min(.95,.48+Math.log2(n+1)*.13)}));
        const g=svgNode('g',{role:'button',tabindex:'0','aria-label':`${group.label}: ${n} ${this.text(n===1?'artist':'artists')}. ${this.text(group.point.regional?'regional':'city')}`});
        g.append(svgNode('circle',{cx:x,cy:y,r:22*unit,fill:'transparent'}));g.append(svgNode('circle',{class:'ad-map-dot',cx:x,cy:y,r:Math.min(13,6+Math.sqrt(n))*unit,fill:'#eed5b6',stroke:'#22202a','stroke-width':1,'vector-effect':'non-scaling-stroke'}));
        const title=svgNode('title');title.textContent=g.getAttribute('aria-label');g.append(title);if(n>1){const count=svgNode('text',{x,y:y+3*unit,'text-anchor':'middle','font-size':9*unit,fill:'#17131d','font-family':'system-ui','font-weight':'650','pointer-events':'none'});count.textContent=String(n);g.append(count);}
        this.on(g,'click',()=>this.selectLocation(group.key));this.on(g,'keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();this.selectLocation(group.key);}});points.append(g);
      }
      const places=this.querySelector('[data-ad-places]');places.replaceChildren();
      for(const group of groups){const button=document.createElement('button');button.type='button';button.className='ad-place';button.setAttribute('aria-pressed',String(this.locationSelect.value===group.key));const copy=document.createElement('span');copy.textContent=group.label;if(group.point?.regional){const small=document.createElement('small');small.textContent=this.text('regional');copy.append(small);}const count=document.createElement('b');count.textContent=String(group.cards.length);button.append(copy,count);this.on(button,'click',()=>this.selectLocation(group.key));places.append(button);}
    }
  }
  if(!customElements.get('aura-artist-directory'))customElements.define('aura-artist-directory',ArtistDirectory);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aura-music-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = async (root) => {
    if (!root || root.dataset.erInitialized === 'true') return;
    root.dataset.erInitialized = 'true';
    const controller = new AbortController();
    let disposed = false;
    const labelNode = root.querySelector('[data-er-labels]');
    const labels = labelNode ? JSON.parse(labelNode.textContent) : {};
    const label = (name) => labels[name] || name;
    requestAnimationFrame(() => root.classList.add('is-page-ready'));
    root.addEventListener('aura:music:dispose', () => {disposed = true;controller.abort();}, {once:true});
    const unload = (event) => {
      if (String(event.detail?.sectionId) === root.dataset.sectionId) root.dispatchEvent(new Event('aura:music:dispose'));
    };
    document.addEventListener('shopify:section:unload', unload, {signal:controller.signal});

    const results = root.querySelector('[data-er-results]');
    if (!results) {
      requestAnimationFrame(() => root.classList.add('is-page-ready'));
      return;
    }

    const PREVIEW_LIMIT_SECONDS = 60;

    
    const paginationState = root.querySelector('[data-er-pagination-state]');
    const paginationShell = root.querySelector('[data-er-pagination-shell]');
    const hydrateCatalog = async () => {
      let nextUrl = paginationState?.dataset.nextUrl || '';
      if (!nextUrl || typeof fetch !== 'function' || typeof DOMParser === 'undefined') {
        if (paginationShell) {
          const note = paginationShell.querySelector('.erdisc__pagination-note');
          if (note) note.textContent = '';
        }
        return;
      }

      const seenProducts = new Set(
        [...results.querySelectorAll('[data-er-release]')].map((card) => card.dataset.productId).filter(Boolean)
      );
      let pageGuard = 0;

      try {
        const visited = new Set();
        while (nextUrl && pageGuard < 100) {
          pageGuard += 1;
          const url = new URL(nextUrl, window.location.origin);
          url.searchParams.set('section_id', root.dataset.sectionId);
          if (url.origin !== location.origin || visited.has(url.href)) throw new Error('Invalid catalog page');
          visited.add(url.href);

          const response = await fetch(url.toString(), {
            signal: AbortSignal.any([controller.signal, AbortSignal.timeout(20000)]),
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });
          if (!response.ok) throw new Error(`Catalog page ${pageGuard + 1} returned ${response.status}`);

          const html = await response.text();
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          const nextResults = documentFragment.querySelector('[data-er-results]');
          if (!nextResults) throw new Error('Catalog section response did not include release rows.');

          [...nextResults.querySelectorAll('[data-er-release]')].forEach((card) => {
            const productId = card.dataset.productId || '';
            if (productId && seenProducts.has(productId)) return;
            if (productId) seenProducts.add(productId);
            results.appendChild(card);
          });

          const nextState = documentFragment.querySelector('[data-er-pagination-state]');
          nextUrl = nextState?.dataset.nextUrl || '';
        }

        if (!nextUrl && paginationShell) paginationShell.hidden = true;
        if (nextUrl && paginationShell) {
          const link = paginationShell.querySelector('a');
          if (link) link.href = nextUrl;
          const note = paginationShell.querySelector('.erdisc__pagination-note');
          if (note) note.textContent = 'More catalog pages are available below.';
        }
      } catch (error) {
        if (disposed) return;
        console.warn('East Rock Music: complete catalog hydration fell back to native pagination.', error);
        if (paginationShell) {
          paginationShell.hidden = false;
          const links = paginationShell.querySelector('nav');
          if (links && nextUrl) {const link=document.createElement('a');link.href=nextUrl;link.textContent=label('more');links.replaceChildren(link);}
          const note = paginationShell.querySelector('.erdisc__pagination-note');
          if (note) note.textContent = '';
        }
      }
    };

    await hydrateCatalog();
    if (disposed || !root.isConnected) return;

    const cards = [...results.querySelectorAll('[data-er-release]')];
    const upcomingSection = root.querySelector('[data-er-upcoming]');
    const upcomingResults = root.querySelector('[data-er-upcoming-results]');
    const upcomingCount = root.querySelector('[data-er-upcoming-count]');

    const localDateKey = () => {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    const todayKey = root.dataset.today || localDateKey();
    const isUpcomingCard = (card) => Boolean(card?.dataset.date && card.dataset.date > todayKey);
    const upcomingCards = cards.filter(isUpcomingCard);
    const releasedCards = cards.filter((card) => !isUpcomingCard(card));

    const search = root.querySelector('[data-er-search]');
    const artistFilter = root.querySelector('[data-er-artist-filter]');
    const typeFilter = root.querySelector('[data-er-type-filter]');
    const genreFilter = root.querySelector('[data-er-genre-filter]');
    const yearSelect = root.querySelector('[data-er-year]');
    const sortSelect = root.querySelector('[data-er-sort]');
    const filterToggle = root.querySelector('[data-er-filter-toggle]');
    const filterPanel = root.querySelector('[data-er-filter-panel]');
    const filterCount = root.querySelector('[data-er-filter-count]');
    const clearButton = root.querySelector('[data-er-clear]');
    const countEls = [...root.querySelectorAll('[data-er-count]')];
    const activeNote = root.querySelector('[data-er-active-note]');
    const empty = root.querySelector('[data-er-empty]');
    const emptyReset = root.querySelector('[data-er-empty-reset]');

    const now = root.querySelector('[data-er-now-playing]');
    const heroTitle = root.querySelector('[data-er-hero-title]');
    const heroArtist = root.querySelector('[data-er-hero-artist]');
    const heroFeatured = root.querySelector('[data-er-hero-featured]');
    const heroMeta = root.querySelector('[data-er-hero-meta]');
    const heroArt = root.querySelector('[data-er-hero-art]');
    const heroProductLinks = [...root.querySelectorAll('[data-er-hero-product-link]')];
    const heroStream = root.querySelector('[data-er-hero-stream]');
    const heroToggle = root.querySelector('[data-er-hero-toggle]');
    const heroSeek = root.querySelector('[data-er-hero-seek]');
    const heroTime = root.querySelector('[data-er-player-time]');
    const heroState = root.querySelector('[data-er-player-state]');
    const ambientA = root.querySelector('[data-er-ambient-a]');
    const ambientB = root.querySelector('[data-er-ambient-b]');

    const normalize = (value) => (value || '').toString().trim().toLowerCase();
    const displayValue = (value) => (value || '').toString().trim();
    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
    const luminance = ([r, g, b]) => (0.2126 * r) + (0.7152 * g) + (0.0722 * b);
    const mix = (from, to, amount) => [
      Math.round(from[0] + ((to[0] - from[0]) * amount)),
      Math.round(from[1] + ((to[1] - from[1]) * amount)),
      Math.round(from[2] + ((to[2] - from[2]) * amount))
    ];
    const distance = (a, b) => Math.hypot(a[0] - b[0], a[1] - b[1], a[2] - b[2]);

    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let rowRevealObserver = null;

    if (!reduceMotion && 'IntersectionObserver' in window) {
      rowRevealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          rowRevealObserver.unobserve(entry.target);
        });
      }, {
        root: null,
        rootMargin: '0px 0px -5% 0px',
        threshold: 0.06
      });
    }

    const prepareRowReveal = (card, index = 0) => {
      if (!card || card.hidden) return;
      card.style.setProperty('--er-reveal-delay', `${Math.min(index, 7) * 38}ms`);

      if (reduceMotion || !rowRevealObserver) {
        card.classList.add('is-revealed');
        card.dataset.erRevealReady = 'true';
        return;
      }

      if (card.dataset.erRevealReady === 'true' && card.classList.contains('is-revealed')) return;

      card.classList.remove('is-revealed');
      rowRevealObserver.unobserve(card);
      rowRevealObserver.observe(card);
      card.dataset.erRevealReady = 'true';
    };

    
    const themeVariableNames = ['--er-accent', '--er-accent-2', '--er-fg', '--er-muted', '--er-highlight'];

    if (now && now.parentElement !== document.body) {
      const staleDock = document.querySelector('#' + CSS.escape('ERDiscographyDock-' + root.dataset.sectionId) + '[data-er-portal="true"]');
      if (staleDock && staleDock !== now) staleDock.remove();

      const rootStyles = window.getComputedStyle(root);
      themeVariableNames.forEach((name) => {
        const value = rootStyles.getPropertyValue(name).trim();
        if (value) now.style.setProperty(name, value);
      });
      document.body.appendChild(now);
      now.dataset.erPortal = 'true';
    }

    const themeAnimations = new Map();
    const THEME_TRANSITION_MS = reduceMotion ? 1 : 1450;

    const parseRgbVariable = (element, name, fallback) => {
      const raw = window.getComputedStyle(element).getPropertyValue(name).trim();
      const values = raw.split(',').map((part) => Number.parseFloat(part.trim()));
      return values.length === 3 && values.every(Number.isFinite) ? values : fallback;
    };

    const setThemeVariable = (name, value, duration = THEME_TRANSITION_MS) => {
      const target = String(value).split(',').map((part) => Number.parseFloat(part.trim()));
      if (target.length !== 3 || target.some((channel) => !Number.isFinite(channel))) {
        root.style.setProperty(name, value);
        if (now) now.style.setProperty(name, value);
        return;
      }

      const previousFrame = themeAnimations.get(name);
      if (previousFrame) cancelAnimationFrame(previousFrame);

      const start = parseRgbVariable(root, name, target);
      const startedAt = performance.now();
      const ease = (t) => t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

      const frame = (time) => {
        const progress = Math.min(1, Math.max(0, (time - startedAt) / duration));
        const eased = ease(progress);
        const current = start.map((channel, index) => Math.round(channel + ((target[index] - channel) * eased)));
        const serialized = current.join(',');
        root.style.setProperty(name, serialized);
        if (now) now.style.setProperty(name, serialized);

        if (progress < 1) {
          themeAnimations.set(name, requestAnimationFrame(frame));
        } else {
          themeAnimations.delete(name);
        }
      };

      themeAnimations.set(name, requestAnimationFrame(frame));
    };

    const formatTime = (seconds) => {
      if (!Number.isFinite(seconds) || seconds < 0) return '--:--';
      const whole = Math.floor(seconds);
      return `${Math.floor(whole / 60)}:${String(whole % 60).padStart(2, '0')}`;
    };

    const genreValues = (card) => displayValue(card.dataset.genre).split('||').map((item) => item.trim()).filter(Boolean);

    const uniqueSorted = (values) => [...new Set(values.filter(Boolean))].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
    const fillSelect = (select, values) => {
      if (!select) return;
      uniqueSorted(values).forEach((value) => {
        const option = document.createElement('option');
        option.value = normalize(value);
        option.textContent = value;
        select.appendChild(option);
      });
    };

    fillSelect(artistFilter, releasedCards.map((card) => displayValue(card.dataset.artist)));
    fillSelect(typeFilter, releasedCards.map((card) => displayValue(card.dataset.type)));
    fillSelect(genreFilter, releasedCards.flatMap(genreValues));

    const currentYear = root.dataset.currentYear || String(new Date().getFullYear());
    const availableYears = [...new Set(releasedCards.map((card) => displayValue(card.dataset.year)).filter(Boolean))]
      .sort((a, b) => Number(b) - Number(a));

    if (yearSelect) {
      yearSelect.replaceChildren();
      const allYears = document.createElement('option');
      allYears.value = '';
      allYears.textContent = 'All years';
      yearSelect.appendChild(allYears);
      availableYears.forEach((year) => {
        const option = document.createElement('option');
        option.value = year;
        option.textContent = year;
        yearSelect.appendChild(option);
      });
      yearSelect.value = '';
    }

    const getFilters = () => ({
      query: normalize(search && search.value),
      artist: normalize(artistFilter && artistFilter.value),
      type: normalize(typeFilter && typeFilter.value),
      genre: normalize(genreFilter && genreFilter.value),
      year: displayValue(yearSelect && yearSelect.value)
    });

    const sortCards = (list) => {
      const sort = sortSelect ? sortSelect.value : 'date-desc';
      return [...list].sort((a, b) => {
        if (sort === 'date-asc' || sort === 'date-desc') {
          const aDate = a.dataset.date ? Date.parse(`${a.dataset.date}T00:00:00`) : 0;
          const bDate = b.dataset.date ? Date.parse(`${b.dataset.date}T00:00:00`) : 0;
          return sort === 'date-asc' ? aDate - bDate : bDate - aDate;
        }
        if (sort === 'title-asc') return displayValue(a.dataset.title).localeCompare(displayValue(b.dataset.title), undefined, { sensitivity: 'base' });
        if (sort === 'artist-asc') return displayValue(a.dataset.artist).localeCompare(displayValue(b.dataset.artist), undefined, { sensitivity: 'base' });
        if (sort === 'price-asc') return (Number(a.dataset.price) || 0) - (Number(b.dataset.price) || 0);
        if (sort === 'price-desc') return (Number(b.dataset.price) || 0) - (Number(a.dataset.price) || 0);
        return 0;
      });
    };

    const buildActiveNote = (filters) => {
      const parts = [];
      if (filters.artist && artistFilter) parts.push(artistFilter.options[artistFilter.selectedIndex]?.textContent || 'Artist');
      if (filters.type && typeFilter) parts.push(typeFilter.options[typeFilter.selectedIndex]?.textContent || 'Type');
      if (filters.genre && genreFilter) parts.push(genreFilter.options[genreFilter.selectedIndex]?.textContent || 'Genre');
      if (filters.year) parts.push(filters.year);
      if (filters.query) parts.push(`“${search.value.trim()}”`);
      return parts.length ? `Filtered by ${parts.join(' · ')}` : '';
    };

    const updateFilterCount = () => {
      const filters = getFilters();
      const count = [filters.artist, filters.type, filters.genre, filters.year].filter(Boolean).length;
      if (!filterCount) return;
      filterCount.hidden = count === 0;
      filterCount.textContent = count;
    };

    const renderUpcoming = () => {
      if (!upcomingSection || !upcomingResults) return;

      const sortedUpcoming = [...upcomingCards].sort((a, b) => {
        const aDate = a.dataset.date ? Date.parse(`${a.dataset.date}T00:00:00`) : Number.MAX_SAFE_INTEGER;
        const bDate = b.dataset.date ? Date.parse(`${b.dataset.date}T00:00:00`) : Number.MAX_SAFE_INTEGER;
        return aDate - bDate;
      });

      upcomingSection.hidden = sortedUpcoming.length === 0;
      if (upcomingCount) {
        upcomingCount.textContent = `${sortedUpcoming.length} scheduled`;
      }

      sortedUpcoming.forEach((card, index) => {
        card.hidden = false;
        card.classList.add('is-upcoming');
        upcomingResults.appendChild(card);
        prepareRowReveal(card, index);
      });
    };

    let currentPage = 1;
    const pageSize = Math.max(12,Number(root.dataset.pageSize)||24);
    const render = (options = {}) => {
      if (!options.keepPage) currentPage = 1;
      const filters = getFilters();
      const filtered = releasedCards.filter((card) => {
        if (filters.year && displayValue(card.dataset.year) !== filters.year) return false;
        if (filters.query && !normalize(card.dataset.search).includes(filters.query)) return false;
        if (filters.artist && normalize(card.dataset.artist) !== filters.artist) return false;
        if (filters.type && normalize(card.dataset.type) !== filters.type) return false;
        if (filters.genre && !genreValues(card).some((genre) => normalize(genre) === filters.genre)) return false;
        return true;
      });

      const sorted = sortCards(filtered);
      const totalPages = Math.max(1,Math.ceil(sorted.length/pageSize));
      currentPage = Math.min(currentPage,totalPages);
      const startIndex = (currentPage-1)*pageSize;
      const pageCards = sorted.slice(startIndex,startIndex+pageSize);
      const visibleSet = new Set(pageCards);
      drawPages(sorted.length,totalPages);

      releasedCards.forEach((card) => {
        const shouldShow = visibleSet.has(card);
        if (!shouldShow) {
          card.hidden = true;
          card.classList.remove('is-revealed');
          card.dataset.erRevealReady = 'false';
          if (rowRevealObserver) rowRevealObserver.unobserve(card);
          return;
        }
        card.hidden = false;
      });

      pageCards.forEach((card, index) => {
        card.classList.remove('is-upcoming');
        results.appendChild(card);
        const numberEl = card.querySelector('[data-er-track-number]');
        if (numberEl) numberEl.textContent = String(startIndex + index + 1);
        prepareRowReveal(card, index);
      });

      countEls.forEach((countEl) => { countEl.textContent = `${sorted.length} release${sorted.length === 1 ? '' : 's'}`; });
      if (activeNote) activeNote.textContent = buildActiveNote(filters);
      if (empty) empty.hidden = sorted.length !== 0;
      results.hidden = sorted.length === 0;

      const hasChanges = Boolean(filters.query || filters.artist || filters.type || filters.genre || filters.year || (sortSelect && sortSelect.value !== 'date-desc'));
      if (clearButton) clearButton.hidden = !hasChanges;
      updateFilterCount();

      const currentlyPlaying = Boolean(activeAudio && !activeAudio.paused);
      if (!currentlyPlaying && sorted.length && (!activeCard || !sorted.includes(activeCard))) {
        const nextPlayable = sorted.find((card) => card.dataset.audioUrl);
        if (nextPlayable) setActiveCard(nextPlayable, false);
      }
    };

    const drawPages = (count,total) => {
      const nav=root.querySelector('[data-er-pages]');if(!nav)return;nav.hidden=total<=1;nav.replaceChildren();
      const make=(page,text,aria)=>{const button=document.createElement('button');button.type='button';button.textContent=text;button.setAttribute('aria-label',aria);button.disabled=page<1||page>total;if(page===currentPage)button.setAttribute('aria-current','page');button.addEventListener('click',()=>{currentPage=page;render({keepPage:true});const library=root.querySelector('.erdisc__library');library?.focus({preventScroll:true});library?.scrollIntoView({behavior:reduceMotion?'instant':'smooth',block:'start'});});return button;};
      nav.append(make(currentPage-1,'‹',label('previous')));
      const pageNumbers=matchMedia('(max-width:600px)').matches?[1,currentPage,total]:[1,currentPage-1,currentPage,currentPage+1,total];
      [...new Set(pageNumbers)].filter(page=>page>0&&page<=total).sort((a,b)=>a-b).forEach(page=>nav.append(make(page,String(page),`${label('page')} ${page}`)));
      nav.append(make(currentPage+1,'›',label('next')));
      const status=document.createElement('span');status.setAttribute('aria-live','polite');status.textContent=`${(currentPage-1)*pageSize+1}–${Math.min(currentPage*pageSize,count)} / ${count}`;nav.append(status);
    };
    const buildSpotlight = () => {
      const host=root.querySelector('[data-er-spotlight]');if(!host)return;
      const newest=[...releasedCards].sort((a,b)=>(b.dataset.date||'').localeCompare(a.dataset.date||'')||(a.dataset.title||'').localeCompare(b.dataset.title||''));
      host.hidden=!newest.length;if(!newest.length)return;
      const create=(tag,className,text)=>{const node=document.createElement(tag);node.className=className;if(text!==undefined)node.textContent=text;return node;};
      const safe=value=>{try{const url=new URL(value,location.origin);return ['http:','https:'].includes(url.protocol)?url.href:'#';}catch{return '#';}};
      const feature=(card,large)=>{
        const item=create('article',large?'erdisc__feature':'erdisc__recent-card');
        const art=create('a','erdisc__feature-art');art.href=safe(card.dataset.productUrl);art.setAttribute('aria-label',card.dataset.title);
        const source=card.querySelector('.erdisc__cover');
        const artworkUrl=card.dataset.imageUrl||source?.currentSrc||source?.getAttribute('src');
        if(artworkUrl){
          const img=document.createElement('img');
          img.className='erdisc__spotlight-cover';img.alt=card.dataset.title||'';
          img.width=large?640:192;img.height=large?640:192;img.loading='eager';img.decoding='async';
          if(large)img.fetchPriority='high';
          const url=new URL(safe(artworkUrl));
          if(url.pathname.includes('/cdn/')||url.hostname.endsWith('.shopify.com'))url.searchParams.set('width',String(img.width));
          img.src=url.href;
          img.addEventListener('error',()=>{const fallback=safe(artworkUrl);if(img.src!==fallback)img.src=fallback;},{once:true});
          art.append(img);
        }else if(source){art.append(source.cloneNode(true));}
        item.append(art);
        const copy=create('div','erdisc__feature-copy');
        if(large)copy.append(create('p','erdisc__feature-kicker',label('latest')));
        const heading=create(large?'h2':'h3','');const title=create('a','',card.dataset.title);title.href=safe(card.dataset.productUrl);heading.append(title);copy.append(heading);
        copy.append(create('p','erdisc__feature-artist',card.dataset.artist));
        copy.append(create('p','erdisc__feature-meta',[card.dataset.type,card.dataset.dateLabel].filter(Boolean).join(' · ')));
        const actions=create('div','erdisc__feature-actions');
        const original=card.querySelector('[data-er-track-play]');
        if(original){const button=create('button',large?'erdisc__feature-button erdisc__feature-button--primary':'erdisc__recent-play');button.type='button';button.dataset.erSpotlightPlay=card.dataset.productId;button.dataset.title=card.dataset.title;button.setAttribute('aria-label',`Play preview of ${card.dataset.title}`);button.setAttribute('aria-pressed','false');for (const name of ['play','pause']) {const symbol=original.querySelector(`.erdisc__track-${name}-icon`)?.cloneNode(true);if(symbol)button.append(symbol);}if(large)button.append(create('span','',label('preview')));button.addEventListener('click',()=>original.click());actions.append(button);}
        if(large){const view=create('a','erdisc__feature-button',label('view'));view.href=safe(card.dataset.productUrl);actions.append(view);}
        copy.append(actions);item.append(copy);return item;
      };
      host.replaceChildren(feature(newest[0],true));
      if(newest.length>1){const recent=create('div','erdisc__recent');recent.setAttribute('aria-label',label('recent'));newest.slice(1,3).forEach(card=>recent.append(feature(card,false)));host.append(recent);}else host.classList.add('is-single');
      applyRootPalette(newest[0]);transitionAmbient(newest[0].dataset.imageUrl);
    };

    const clearFilters = () => {
      if (search) search.value = '';
      if (artistFilter) artistFilter.value = '';
      if (typeFilter) typeFilter.value = '';
      if (genreFilter) genreFilter.value = '';
      if (yearSelect) yearSelect.value = '';
      if (sortSelect) sortSelect.value = 'date-desc';
      render();
    };

    if (filterToggle && filterPanel) {
      filterToggle.addEventListener('click', () => {
        const open = filterToggle.getAttribute('aria-expanded') !== 'true';
        filterToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        filterPanel.dataset.open = open ? 'true' : 'false';
      });
    }

    [artistFilter, typeFilter, genreFilter, sortSelect, yearSelect].forEach((control) => {
      if (control) control.addEventListener('change', render);
    });
    if (search) {
      let timer;
      search.addEventListener('input', () => {
        window.clearTimeout(timer);
        timer = window.setTimeout(render, 80);
      });
    }
    if (clearButton) clearButton.addEventListener('click', clearFilters);
    if (emptyReset) emptyReset.addEventListener('click', clearFilters);

    const soften = ([r, g, b]) => {
      const lum = luminance([r, g, b]);
      let amount = .025;
      const target = 154;
      if (lum < 48) amount = .18;
      else if (lum > 220) amount = .11;

      const softened = [
        clamp((r * (1 - amount)) + (target * amount), 24, 238),
        clamp((g * (1 - amount)) + (target * amount), 24, 238),
        clamp((b * (1 - amount)) + (target * amount), 24, 238)
      ];
      const softenedLum = luminance(softened);

      return softened.map((channel) =>
        Math.round(clamp(softenedLum + ((channel - softenedLum) * 1.28), 24, 240))
      );
    };

    const extractPalette = (image) => {
      const canvas = document.createElement('canvas');
      const size = 36;
      canvas.width = size;
      canvas.height = size;
      const context = canvas.getContext('2d', { willReadFrequently: true });
      if (!context) return null;
      context.drawImage(image, 0, 0, size, size);
      const pixels = context.getImageData(0, 0, size, size).data;
      const buckets = new Map();

      for (let i = 0; i < pixels.length; i += 4) {
        if (pixels[i + 3] < 180) continue;
        const r = pixels[i];
        const g = pixels[i + 1];
        const b = pixels[i + 2];
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        const saturation = max === 0 ? 0 : (max - min) / max;
        const lum = luminance([r, g, b]);
        if (lum < 15 || lum > 243) continue;
        const key = `${Math.round(r / 32) * 32},${Math.round(g / 32) * 32},${Math.round(b / 32) * 32}`;
        const weight = .38 + (saturation * 2.05);
        const bucket = buckets.get(key) || { score: 0, count: 0, r: 0, g: 0, b: 0 };
        bucket.score += weight;
        bucket.count += 1;
        bucket.r += r;
        bucket.g += g;
        bucket.b += b;
        buckets.set(key, bucket);
      }

      const ranked = [...buckets.values()]
        .filter((bucket) => bucket.count >= 2)
        .map((bucket) => ({
          score: bucket.score,
          color: [
            Math.round(bucket.r / bucket.count),
            Math.round(bucket.g / bucket.count),
            Math.round(bucket.b / bucket.count)
          ]
        }))
        .sort((a, b) => b.score - a.score);

      if (!ranked.length) return null;
      const chromatic=ranked.filter(({color,score})=>{
        const high=Math.max(...color),low=Math.min(...color);
        return high-low>28&&(high-low)/Math.max(1,high)>.22&&score>=ranked[0].score*.08;
      });
      const primary = soften((chromatic[0]||ranked[0]).color);
      let secondary = primary;
      for (const candidate of [...chromatic,...ranked]) {
        const color = soften(candidate.color);
        if (distance(primary, color) > 66) {
          secondary = color;
          break;
        }
      }
      return { primary, secondary };
    };

    const applyCardPalette = (card, palette) => {
      if (!palette) return;
      let primary = palette.primary;
      let secondary = palette.secondary;
      if (luminance(primary) < 72) primary = mix(primary, [255,255,255], .26);
      if (luminance(primary) > 220) primary = mix(primary, [0,0,0], .12);

      
      primary = mix(primary, [150, 152, 156], .035);
      secondary = mix(secondary, primary, .10);

      card.style.setProperty('--er-row-accent', primary.join(','));
      card.style.setProperty('--er-row-accent-2', secondary.join(','));
      card.dataset.erPalette = `${primary.join('-')}|${secondary.join('-')}`;
    };

    const paletteLoads = new Map();
    let paletteRequest = 0;
    const loadPalette = (card) => {
      const source=card.dataset.imageUrl;
      if(!source)return Promise.resolve(null);
      if(paletteLoads.has(source))return paletteLoads.get(source);
      const pending=new Promise(resolve=>{
        const image=new Image();image.crossOrigin='anonymous';image.decoding='async';
        image.onload=()=>{try{resolve(extractPalette(image));}catch{resolve(null);}};
        image.onerror=()=>resolve(null);
        const url=new URL(source,location.origin);
        if(url.pathname.includes('/cdn/')||url.hostname.endsWith('.shopify.com'))url.searchParams.set('width','96');
        image.src=url.href;
      });
      paletteLoads.set(source,pending);
      return pending;
    };
    const applyRootPalette = async (card) => {
      const request=++paletteRequest;
      if(!card)return;
      if(!card.dataset.erPalette){
        const palette=await loadPalette(card);
        if(disposed||request!==paletteRequest)return;
        if(palette)applyCardPalette(card,palette);
      }
      if(disposed||request!==paletteRequest||!card.dataset.erPalette)return;
      const [p,s]=card.dataset.erPalette.split('|');
      const primary=p.split('-').map(Number);
      setThemeVariable('--er-accent',primary.join(','));
      setThemeVariable('--er-accent-2',s.split('-').join(','));
      setThemeVariable('--er-fg',mix([250,249,253],primary,.12).join(','));
      setThemeVariable('--er-muted',mix([218,218,226],primary,.20).join(','));
      setThemeVariable('--er-highlight',mix([255,250,255],primary,.28).join(','));
    };

    const sampleCard = (card) => {
      if (card.dataset.erPaletteReady === 'true') return;
      const image = card.querySelector('.erdisc__cover:not(.erdisc__cover--placeholder)');
      if (!image) return;
      const run = () => {
        try {
          const palette = extractPalette(image);
          if (palette) applyCardPalette(card, palette);
          card.dataset.erPaletteReady = 'true';
        } catch (error) {
          card.dataset.erPaletteReady = 'failed';
        }
      };
      if (image.complete && image.naturalWidth > 0) run();
      else image.addEventListener('load', run, { once: true });
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          sampleCard(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '240px 0px' });
      cards.forEach((card) => observer.observe(card));
    } else {
      cards.forEach(sampleCard);
    }

    let ambientFront = 'a';
    let ambientRequest = 0;
    const transitionAmbient = (imageUrl) => {
      if (!imageUrl || !ambientA || !ambientB) return;
      const requestId = ++ambientRequest;
      const preload = new Image();
      preload.onload = () => {
        if (requestId !== ambientRequest) return;
        const next = ambientFront === 'a' ? ambientB : ambientA;
        const current = ambientFront === 'a' ? ambientA : ambientB;
        next.classList.remove('is-visible');
        next.style.backgroundImage = `url("${imageUrl.replace(/"/g, '%22')}")`;
        void next.offsetWidth;
        requestAnimationFrame(() => {
          next.classList.add('is-visible');
          current.classList.remove('is-visible');
          ambientFront = ambientFront === 'a' ? 'b' : 'a';
        });
      };
      preload.src = imageUrl;
    };

    const initialYear = yearSelect ? yearSelect.value : '';
    const playableCards = [
      ...releasedCards.filter((card) => card.dataset.audioUrl),
      ...upcomingCards.filter((card) => card.dataset.audioUrl)
    ].sort((a, b) => {
      const aUpcoming = isUpcomingCard(a);
      const bUpcoming = isUpcomingCard(b);
      if (aUpcoming !== bUpcoming) return aUpcoming ? 1 : -1;
      const aDate = a.dataset.date ? Date.parse(`${a.dataset.date}T00:00:00`) : 0;
      const bDate = b.dataset.date ? Date.parse(`${b.dataset.date}T00:00:00`) : 0;
      return aUpcoming ? aDate - bDate : bDate - aDate;
    });
    let activeCard =
      playableCards.find((card) => (!initialYear || card.dataset.year === initialYear) && card.classList.contains('is-active')) ||
      playableCards.find((card) => !initialYear || card.dataset.year === initialYear) ||
      playableCards[0] ||
      null;
    let activeAudio = activeCard ? activeCard.querySelector('[data-er-track-audio]') : null;

    const getPreviewDuration = (audio) => {
      if (!audio) return PREVIEW_LIMIT_SECONDS;
      const sourceDuration = Number.isFinite(audio.duration) ? audio.duration : 0;
      return sourceDuration > 0 ? Math.min(sourceDuration, PREVIEW_LIMIT_SECONDS) : PREVIEW_LIMIT_SECONDS;
    };

    const syncPlayerUI = () => {
      if (!now || !activeAudio || !heroSeek || !heroTime) return;
      const duration = getPreviewDuration(activeAudio);
      const current = Math.min(Number.isFinite(activeAudio.currentTime) ? activeAudio.currentTime : 0, duration);
      const progress = duration > 0 ? clamp((current / duration) * 100, 0, 100) : 0;
      heroSeek.value = progress.toFixed(2);
      now.style.setProperty('--er-preview-progress', `${progress}%`);
      heroTime.textContent = `${formatTime(current)} / ${formatTime(duration)}`;
    };

    const syncPlayingState = () => {
      const playing = Boolean(activeAudio && !activeAudio.paused);
      root.classList.toggle('is-playing', playing);
      if (now) {now.classList.toggle('is-playing', playing);if(playing)now.hidden=false;}
      root.querySelectorAll('[data-er-spotlight-play]').forEach(button=>{const on=playing&&button.dataset.erSpotlightPlay===activeCard?.dataset.productId;button.setAttribute('aria-pressed',String(on));button.classList.toggle('is-playing',on);button.setAttribute('aria-label',`${on?'Pause':'Play'} preview of ${button.dataset.title}`);});
      cards.forEach((card) => card.classList.toggle('is-playing', card === activeCard && playing));
      cards.forEach((card) => {
        const button = card.querySelector('[data-er-track-play]');
        if (!button) return;
        const isPlaying = card === activeCard && playing;
        button.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
        button.setAttribute('aria-label', `${isPlaying ? 'Pause' : 'Play'} preview of ${card.dataset.title}`);
      });
      if (heroToggle) {
        heroToggle.setAttribute('aria-pressed', playing ? 'true' : 'false');
        heroToggle.setAttribute('aria-label', playing ? 'Pause preview' : 'Play preview');
      }
      if (heroState) heroState.textContent = playing ? 'Playing' : 'Preview ready';
    };

    const resetAudio = (audio) => {
      if (!audio) return;
      audio.pause();
      try { audio.currentTime = 0; } catch (error) {}
    };

    const updateHeroFromCard = (card) => {
      if (!card || !now) return;
      if (heroTitle) heroTitle.textContent = card.dataset.title || '';
      if (heroArtist) heroArtist.textContent = card.dataset.artist || '';
      if (heroFeatured) {
        const featured = card.dataset.featured || '';
        heroFeatured.hidden = !featured;
        heroFeatured.textContent = featured ? ` · feat. ${featured}` : '';
      }
      if (heroMeta) {
        heroMeta.replaceChildren();
        [card.dataset.type, card.dataset.dateLabel, card.dataset.priceLabel].filter(Boolean).forEach((value) => {
          const span = document.createElement('span');
          span.textContent = value;
          heroMeta.appendChild(span);
        });
      }
      heroProductLinks.forEach((link) => { link.href = card.dataset.productUrl || '#'; });
      if (heroStream) {
        const streamingUrl = card.dataset.streamingUrl || '';
        const preSaveUrl = card.dataset.preSaveUrl || '';
        const destination = streamingUrl || preSaveUrl;
        heroStream.hidden = !destination;
        if (destination) heroStream.href = destination;
        heroStream.setAttribute('aria-label', streamingUrl ? 'Stream release' : 'Pre-save release');
        heroStream.setAttribute('title', streamingUrl ? 'Stream release' : 'Pre-save release');
      }
      const imageUrl = card.dataset.imageUrl || '';
      if (heroArt && imageUrl && heroArt.src !== imageUrl) {
        const preload = new Image();
        preload.onload = () => {
          heroArt.classList.add('is-changing');
          window.setTimeout(() => {
            heroArt.src = imageUrl;
            heroArt.removeAttribute('srcset');
            heroArt.removeAttribute('sizes');
            heroArt.alt = card.dataset.title || '';
            requestAnimationFrame(() => {
              requestAnimationFrame(() => heroArt.classList.remove('is-changing'));
            });
          }, 210);
        };
        preload.src = imageUrl;
      }
      if(activeAudio && !activeAudio.paused){transitionAmbient(imageUrl);applyRootPalette(card);}
    };

    const setActiveCard = (card, playAfter = false) => {
      if (!card || !card.dataset.audioUrl) return;
      const nextAudio = card.querySelector('[data-er-track-audio]');
      if (!nextAudio) return;

      if (activeAudio && activeAudio !== nextAudio) resetAudio(activeAudio);
      cards.forEach((item) => item.classList.toggle('is-active', item === card));
      activeCard = card;
      activeAudio = nextAudio;
      updateHeroFromCard(card);
      syncPlayerUI();
      syncPlayingState();

      if (playAfter) {
        const duration = getPreviewDuration(activeAudio);
        if (activeAudio.currentTime >= duration - .05) activeAudio.currentTime = 0;
        activeAudio.play().catch(() => syncPlayingState());
      }
    };

    cards.forEach((card) => {
      const button = card.querySelector('[data-er-track-play]');
      const audio = card.querySelector('[data-er-track-audio]');
      if (!button || !audio) return;

      button.addEventListener('click', () => {
        if (card === activeCard) {
          if (audio.paused) audio.play().catch(() => syncPlayingState());
          else audio.pause();
        } else {
          setActiveCard(card, true);
        }
      });

      audio.addEventListener('loadedmetadata', () => { if (audio === activeAudio) syncPlayerUI(); });
      audio.addEventListener('durationchange', () => { if (audio === activeAudio) syncPlayerUI(); });
      audio.addEventListener('timeupdate', () => {
        if (audio !== activeAudio) return;
        const duration = getPreviewDuration(audio);
        if (audio.currentTime >= duration - .05) {
          resetAudio(audio);
          syncPlayerUI();
          syncPlayingState();
          return;
        }
        syncPlayerUI();
      });
      audio.addEventListener('play', () => {
        transitionAmbient(card.dataset.imageUrl);applyRootPalette(card);
        document.querySelectorAll('audio,video').forEach(media=>{if(media!==audio&&!media.paused)media.pause();});
        cards.forEach((otherCard) => {
          if (otherCard === card) return;
          const otherAudio = otherCard.querySelector('[data-er-track-audio]');
          if (otherAudio && !otherAudio.paused) resetAudio(otherAudio);
        });
        if (card !== activeCard) setActiveCard(card, false);
        syncPlayingState();
      });
      audio.addEventListener('pause', syncPlayingState);
      audio.addEventListener('ended', () => {
        resetAudio(audio);
        syncPlayerUI();
        syncPlayingState();
      });
      audio.addEventListener('error', () => {
        button.disabled = true;
        button.setAttribute('aria-label', 'Audio preview unavailable');
        root.querySelectorAll('[data-er-spotlight-play]').forEach(control=>{if(control.dataset.erSpotlightPlay===card.dataset.productId){control.disabled=true;control.setAttribute('aria-label','Audio preview unavailable');}});
        if (audio === activeAudio && heroState) heroState.textContent = 'Preview unavailable';
      });
    });

    if (heroToggle) {
      heroToggle.addEventListener('click', () => {
        if (!activeAudio) return;
        if (activeAudio.paused) {
          const duration = getPreviewDuration(activeAudio);
          if (activeAudio.currentTime >= duration - .05) activeAudio.currentTime = 0;
          activeAudio.play().catch(() => syncPlayingState());
        } else {
          activeAudio.pause();
        }
      });
    }

    if (heroSeek) {
      heroSeek.addEventListener('input', () => {
        if (!activeAudio) return;
        const duration = getPreviewDuration(activeAudio);
        activeAudio.currentTime = (clamp(Number(heroSeek.value) || 0, 0, 100) / 100) * duration;
        syncPlayerUI();
      });
    }

    if (activeCard) {
      updateHeroFromCard(activeCard);
      syncPlayerUI();
      syncPlayingState();
    }

    
    root.addEventListener('aura:music:dispose', () => {
      if(activeAudio)resetAudio(activeAudio);
      if(now)now.remove();
      rowRevealObserver?.disconnect();
      themeAnimations.forEach(frame=>cancelAnimationFrame(frame));
    }, {once:true});

    buildSpotlight();
    renderUpcoming();
    render();

    
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        root.classList.add('is-page-ready');
        if (now) now.classList.add('is-dock-ready');
      });
    });
  };
  const scan=(scope)=>{scope.querySelectorAll?.('.aura-music-page').forEach(root=>initialize(root).catch(()=>{root.classList.add('is-page-ready');}));};
  scan(document);
  if(!window.auraMusicSectionListener){window.auraMusicSectionListener=true;document.addEventListener('shopify:section:load',event=>scan(event.target));}
})();
  } catch(e) { console.error(e); }
})();

})();
